import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#traffic-arrow_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.844 4.706a1.35 1.35 0 0 1 .337.663l2.849 14.787a1.33 1.33 0 0 1-.668 1.43c-.247.14-.533.198-.815.164l-.105-.017a1.3 1.3 0 0 1-.648-.337l-4.932-4.583L5.3 18.315a1.33 1.33 0 0 1-.829-.069l-.096-.046a1.33 1.33 0 0 1-.528-.504l-.013-.021a1.3 1.3 0 0 1-.183-.696l.005-.104c.027-.279.142-.542.327-.752l9.861-11.381a1.342 1.342 0 0 1 2.001-.036zM5.427 16.745l6.875-1.573 5.165 4.8-2.698-14.008-9.342 10.782z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "traffic-arrow_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 .735h24v24H0z"
}))));
const ForwardRef = forwardRef(SvgComponent);
export const TrafficArrowIcon = ForwardRef;